import { Endowment } from 'modules/cm/pages/CaseDetailsPage/subPages/RepaymentStrategy/sections';
import { connect } from 'react-redux';
import { RootState } from 'store/configureStore';
import { addEndowment, updateEndowment, removeEndowment } from '../useCases';

const state = (state: RootState) => {
  return {};
};
const dispatchers = {
  addNew: addEndowment,
  removeOne: removeEndowment,
  updateOne: updateEndowment,
};

export default connect(state, dispatchers)(Endowment);
